import { Outlet, Link } from "react-router-dom";
import { useMsal, useAccount } from "@azure/msal-react";

const LIAISE_LIFE_URL = "https://liaisegroup.sharepoint.com/sites/LiaiseWorkspace";

export function AppShell() {
  const { accounts, instance } = useMsal();
  const account = useAccount(accounts[0]);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-liaise-navy text-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src="/liaise-wordmark-white.svg" alt="Liaise" className="h-7 w-auto" />
            <span className="text-white/40">|</span>
            <span className="font-medium">Pricing</span>
          </Link>
          <div className="flex items-center gap-3 sm:gap-4 text-sm">
            <a href={LIAISE_LIFE_URL} target="_top" rel="noreferrer" className="hidden sm:inline text-xs text-white/70 hover:text-white whitespace-nowrap">
              ← Liaise Life
            </a>
            <span className="opacity-80 hidden md:inline">{account?.name || account?.username}</span>
            <button
              onClick={() => instance.logoutRedirect()}
              className="opacity-80 hover:opacity-100 underline text-xs sm:text-sm"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1">
        <div className="max-w-6xl mx-auto px-6 py-8"><Outlet /></div>
      </main>
      <footer className="text-center text-xs text-slate-400 py-6">
        Your goals are our goals.
      </footer>
    </div>
  );
}
